import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import Link from 'next/link';
import { classnames } from '@@client/lib/classes';
import { useCart } from '@@client/cart/cart-hooks';
import NoSSR from '@@client/components/NoSSR';
export default function CartText(_ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? '/cart' : _ref$href,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Cart' : _ref$label,
      _ref$isCurrent = _ref.isCurrent,
      isCurrent = _ref$isCurrent === void 0 ? false : _ref$isCurrent,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  var cart = useCart();
  var numItems = Object.keys(cart.items).length;
  var haveItems = numItems > 0;
  var itemS = numItems === 1 ? 'Item' : 'Items';
  var classNames = classnames(['cart', haveItems ? 'not-empty' : 'is-empty', isCurrent ? 'is-current' : 'not-current', className]);
  return /*#__PURE__*/_jsx(NoSSR, {
    children: /*#__PURE__*/_jsx(Link, {
      href: href,
      children: /*#__PURE__*/_jsxs("a", {
        className: classNames,
        children: [label, " ", haveItems ? "(".concat(numItems, " ").concat(itemS, ")") : '']
      })
    })
  });
}